import React from "react";

import { useIntl } from "react-intl";

import { EntityTypeSupportingNotes } from "@mapmycustomers/shared/types/entity";
import { TextField } from "@mapmycustomers/ui";

import { getSourceObjectDisplayName, SourceObjectMessageArgs } from "@app/util/ui";

interface Props {
  entityName: string;
  entityType: EntityTypeSupportingNotes;
  sourceObjectArgs: SourceObjectMessageArgs;
}

const EntityLabel = ({ entityName, entityType, sourceObjectArgs }: Props) => {
  const intl = useIntl();

  return (
    <TextField
      defaultValue={entityName}
      disabled
      label={getSourceObjectDisplayName(intl, entityType, sourceObjectArgs)}
    />
  );
};

export default EntityLabel;
